export default {
  "PROFILE": "Profile"
};